import React from "react"
import Button from "src/components/core/atoms/button"

import classnames from "classnames/bind"
import { container, alert, success, hasItems, main } from "./snackbar.module.css"
const cx = classnames.bind( { container, alert, success, hasItems, main } )

const CartItems = ( { variant, itemsCnt, ctx, header } ) => {
  return (
    <aside className={ cx( 'container', variant, { 'hasItems': itemsCnt > 0 } ) }>
      <section className={ cx( 'main' ) }>
        { header && (
          <header>
            <h1>{ header }</h1>
          </header>
        ) }
        <p>
          { itemsCnt === 0 && `No services selected.` }
          { itemsCnt === 1 && `There is ${ itemsCnt } service in your booking.` }
          { itemsCnt > 1 && `There are ${ itemsCnt } services in your booking.` }
        </p>
        { ctx && (
          <Button variant="solid" onClick={ ctx.action }>{ ctx.text }</Button>
        ) }
      </section>
    </aside>
  )
}

export default CartItems
